import i18next from 'i18next';
import isMaxFileCountExceed from './isMaxFileCountExceed';
import isMaxFileSizeExceed from './isMaxFileSizeExceed';
import isAllowedMimeType from './isAllowedMimeType';

const getT = () => i18next.getFixedT(null, 'DropZone');

const getValidationError = (
    attachedFiles,
    maxTotalFilesCount,
    maxTotalFilesSizeMB,
    allowedMimeTypes,
) => {
    const t = getT();

    if (isMaxFileCountExceed(attachedFiles, maxTotalFilesCount)) {
        return t(
            'theme.dropzone.max-number-of-files',
            { maxNumberOfFiles: maxTotalFilesCount },
        );
    }

    if (isMaxFileSizeExceed(attachedFiles, maxTotalFilesSizeMB)) {
        return t(
            'theme.dropzone.overall-max-file-size',
            { maxFilesSize: `${maxTotalFilesSizeMB} MB` },
        );
    }

    if (!isAllowedMimeType(attachedFiles, allowedMimeTypes)) {
        return t('theme.dropzone.not_allowed_file_mime_type');
    }

    return null;
};

export default getValidationError;
